import script from "./PurchaseOrderItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseOrderItemDetails.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseOrderItemDetails.vue?vue&type=style&index=0&id=cc475d48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc475d48"]])

export default __exports__